<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>奖品设置</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-card class="box-card" style="margin-bottom: 20px;">
			<el-form :inline="true" class="user-search" :model="formInline">
				<el-row>
					<el-col :span="4">	
					
						<el-form-item label="奖品周期类型：">
							<el-select v-model="formInline.rankType" placeholder="选择奖品周期类型" style="width: 150px;" clearable>
								<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
									:key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">	
						<el-form-item label="奖品期数：">
							<el-input  v-model="formInline.weekSort"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">	
						<el-form-item label="奖品等级：">
							<el-select v-model="formInline.goodsLevel" placeholder="选择奖品等级" style="width: 150px;" clearable>
								<el-option :label="item" :value="item" v-for="item in 10" :key="item"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">	
						<el-form-item label="奖品名称：">
							<el-input size="small" placeholder="请输入奖品名称" v-model="formInline.goodsName" style="width: 150px;" clearable></el-input>
						</el-form-item>
					</el-col>
				
				
					<!-- <el-col :span="6">	
						<el-form-item label="选定时间：">
							<datatime v-model="formInline.choiceTime" catename="choiceTime"></datatime>
							
						</el-form-item>
						
					</el-col> -->
					<el-col :span="4">	
						<el-form-item>
							<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						</el-form-item>
						<el-form-item>
							<el-button size="small" type="danger" icon="el-icon-plus" @click="handleadd">新增</el-button>
						</el-form-item>
						<el-form-item>
							<el-button size="small" type="primary" @click="decernerVisible = true">颁奖</el-button>
						</el-form-item>
						
					</el-col>
				</el-row>
			
	
			</el-form>
		</el-card>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column type="index" width="50" align="center"> </el-table-column>
			<el-table-column prop="lastVersion" label="奖品周期类型" align="center">
				<template slot-scope="scope">
					{{scope.row.rankType == 'week'?'周':(scope.row.rankType == 'month'?'月':'年')}}
				</template>
			</el-table-column>
			<el-table-column prop="lastVersion" label="奖品期数" align="center">
				<template slot-scope="scope">
					第{{scope.row.weekSort}}期
				</template>
			</el-table-column>
			<el-table-column prop="lastVersion" label="周期时间" align="center">
					<template slot-scope="scope">
						{{web.formatTime(scope.row.rewardTime,'Y-M-D h:m')}}
						--
						{{web.formatTime(scope.row.rewardEndTime,'Y-M-D h:m')}}
					</template>
			</el-table-column>
			<el-table-column prop="goodsLevel" label="奖品等级" align="center">
			</el-table-column>
			<el-table-column prop="goodsName" label="奖品名称" align="center"> </el-table-column>
			<el-table-column prop="goodsDesc" label="奖品描述" align="center"></el-table-column>
			<el-table-column prop="goodsSize" label="奖品数量" align="center"></el-table-column>
			<el-table-column prop="goodsValue" label="奖品价值" align="center"></el-table-column>
			<el-table-column prop="lastVersion" label="奖品图片" align="center">
				<template slot-scope="scope">
					<el-image style="width: 60px;height: 60px;" :src="scope.row.goodsImg"
						:preview-src-list="[scope.row.goodsImg]">
					</el-image>
				</template>
			</el-table-column>


			<el-table-column label="获奖用户" align="center">
				<template slot-scope="scope">
					{{scope.row.username?scope.row.username:'--'}}
				</template>
			</el-table-column>
			<el-table-column label="用户头像" align="center">
				<template slot-scope="scope">
					<el-image v-if="scope.row.userHead" style="width: 60px;height: 60px;" :src="scope.row.userHead"
						:preview-src-list="[scope.row.userHead]">
					</el-image>
					<div v-else>--</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleedit(scope.row)">
						编辑
					</el-button>
					<el-button size="mini" @click="handledelete(scope.row)">
						删除
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
		<!-- 颁奖 -->
		<el-dialog :close-on-click-modal="false" title="颁奖" :visible.sync="decernerVisible" width="500px">
			<el-form label-width="120px">
				<el-form-item label="类别:">
					<el-select v-model="editbj.rankType" placeholder="类别" style="width: 300px;">
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="奖品期数:">
				<el-input v-model="editbj.weekSort" style="width: 300px;"></el-input>
				</el-form-item>
				<!-- <el-form-item label="选定时间：">
					<datatime v-model="editbj.choiceTime" catename="choiceTime"></datatime>
				</el-form-item> -->
			</el-form>
			<span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;">
				<el-button @click="decernerVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitdecerner">提交</el-button>
			
			</span>
		</el-dialog>
		<!-- 设置奖品-->
		<el-dialog :close-on-click-modal="false" title="设置" :visible.sync="dialogVisible" width="500px">
			<el-form label-width="120px"    :model="editForm"  :rules="rules"  ref="editForm">
				<el-form-item label="奖品周期类型:"   :rules="rules.select" prop="rankType">
					<el-select v-model="editForm.rankType" placeholder="奖品周期类型" style="width: 300px;">
						<el-option :label="item.name" :value="item.status" v-for="(item,index) in rankType"
							:key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="奖品期数："  :rules="rules.input" prop="weekSort">
					<el-input  v-model="editForm.weekSort" style="width: 300px;"></el-input>
				</el-form-item>
			
				<el-form-item label="奖品等级:" :rules="rules.select" prop="goodsLevel">
					<el-select v-model="editForm.goodsLevel" placeholder="奖品等级" style="width: 300px;">
						<el-option :label="item" :value="item" v-for="item in 10" :key="item"></el-option>
					</el-select>
				</el-form-item>
			
				
				<el-form-item label="奖品名称:"  :rules="rules.input" prop="goodsName">
					<el-input v-model="editForm.goodsName" style="width: 300px;"></el-input>
				</el-form-item>
				<el-form-item label="奖品描述:" :rules="rules.input" prop="goodsDesc">
					<el-input v-model="editForm.goodsDesc" style="width: 300px;"></el-input>
				</el-form-item>
				
				<el-form-item label="奖品价值:" >
					<el-input v-model="editForm.goodsValue" style="width: 300px;" ></el-input>
				</el-form-item>
				<!-- <el-form-item label="奖品数量:" :rules="rules.input" prop="goodsSize">
					<el-input v-model="editForm.goodsSize" style="width: 300px;"></el-input>
				</el-form-item> -->
				<el-form-item label="选定时间：" :rules="rules.select" prop="goodsLevel">
					<!-- <datatime v-model="editForm.choiceTime" catename="choiceTime"></datatime> -->
					<datapicker @click="changetimee"></datapicker>
					
				</el-form-item>
				<el-form-item label="图片:" :rules="rules.img" prop="goodsImg">
					<uploadone :url="editForm.goodsImg" cateName="goodsImg" @click="uploadone"></uploadone>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer" style="display: flex;justify-content: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitedit('editForm')">提交</el-button>

			</span>
		</el-dialog>


	</div>
</template>

<script>
	import {
		delRewardGoods,
		addRewardGoods,
		getRewardGoods,
		setAward
	} from '../../api/basisMG.js'
	import uploadone from '@/components/uploadone'
	import ruleMixin from '@/utils/ruleMixin'

	// import uploadwgt from '@/components/uploadwgt'
	// 导出模块
	export default {
		components: {
			// uploadwgt,
			uploadone
		},
		mixins: [ruleMixin],
		// 模块数据
		data() {
			//数据  
			return {
				editbj:{},
				decernerVisible:false,
				rankType: [{
						name: '周',
						status: 'week'
					},
					{
						name: '月',
						status: 'month'
					},
					{
						name: '年',
						status: 'year'
					},
				],
				goodsImg: '',
				loading: true,
				visible: false,
				listData: [],
				dialogVisible: false,
				formInline: {
					start: 0,
					length: 10
				},
				editForm: {},
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 10,
					total: 10,
					start: 0,
					length: 10
				},
			}
		},


		watch: {},

		methods: {
			changetimee(val) {
			
				if (val.length) {
					this.editForm.rewardTime = val[0]
					this.editForm.statisEndTime = val[1]
				} else {
					this.editForm.rewardTime = ""
					this.editForm.statisEndTime = ""
				}
			},
			uploadone(data) {
				this.editForm.goodsImg = data
			},
			handleUpload(url) {
				// this.editForm.wgtUrl = url
				this.$set(this.editForm, 'wgtUrl', url)
				console.log(this.editForm.wgtUrl)
			},
			handleUpload1(url) {
				this.$set(this.editForm, 'pkgUrl', url)
				// this.editForm.pkgUrl = url
				console.log(this.editForm.wgtUrl1)
			},
			handleadd() {
				this.dialogVisible = true
				this.editForm = {}

			},
			handleedit(row) {
				this.dialogVisible = true
				this.editForm = Object.assign({}, row)
			},
			handledelete(row) {
				this.$confirm('确认删除吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					delRewardGoods({
						id: row.id
					}).then(res => {
						if (res.code == '200') {
							this.$message({
								message: '删除成功',
								type: 'success'
							})
							this.getdata()
						}

					})
				})

			},
			submitedit(formName) {
				let param = this.editForm
				// this.$confirm('确认提交吗', '提示', {
				// 			confirmButtonText: '确认',
				// 			cancelButtonText: '取消',
				// 			type: 'warning'
				// 		}).then(() => {
				// 			addRewardGoods(param).then(res => {
				// 				console.log(res)
				// 				if (res.code == '200') {
				// 					this.$message({
				// 						message: '提交成功',
				// 						type: 'success'
				// 					})
				// 					this.dialogVisible = false
				// 					this.getdata()
				// 				}

				// 			})

				// 		})
				this.$refs[formName].validate((valid) => {
					console.log(valid)
					if (valid) {
						this.$confirm('确认提交吗', '提示', {
							confirmButtonText: '确认',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							addRewardGoods(param).then(res => {
								console.log(res)
								if (res.code == '200') {
									this.$message({
										message: '提交成功',
										type: 'success'
									})
									this.dialogVisible = false
									this.getdata()
								}

							})

						})
					}
				})			
			},
			submitdecerner(){
				let param = this.editbj
				// param.upgradeId = this.editForm.id
				this.$confirm('确认颁奖吗', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					setAward(param).then(res => {
						console.log(res)
						if (res.code == '200') {
							this.$message({
								message: '提交成功',
								type: 'success'
							})
							this.decernerVisible = false
							this.getdata()
						}
				
					})
				
				})
			},
			getdata() {
				getRewardGoods(this.formInline).then(res => {
					if (res.code == 200) {
						this.listData = res.data.content
						this.loading = false
						this.pageparm.total = res.data.totalElements
					}
				})
			},
			// 分页插件事件
			callFather(parm) {
				this.pageparm.currentPage = parm.currentPage
				this.pageparm.pageSize = parm.pageSize
				this.pageparm.start = parm.currentPage - 1
				this.pageparm.length = parm.pageSize
				this.formInline.start = parm.currentPage - 1
				this.formInline.length = parm.pageSize
				this.getdata(this.formInline)
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		created() {

			this.getdata()
		},
		// 挂载前状态(里面是操作)
		beforeMount() {},
		// 挂载结束状态(里面是操作)
		mounted() {},
		// 更新前状态(里面是操作)
		beforeUpdate() {},
		// 更新完成状态(里面是操作)
		updated() {},
		// 销毁前状态(里面是操作)
		beforeDestroy() {},
		// 销毁完成状态(里面是操作)
		destroyed() {}
	};
</script>

<style scoped>

</style>
